import type { Primitive, QueryValue } from './types';

export function toSearchParams(obj: Record<string, QueryValue>): URLSearchParams {
  const params = new URLSearchParams();

  function appendParam(key: string, value: Primitive): void {
    if (typeof value !== 'undefined') {
      params.append(key, String(value));
    }
  }

  function buildQuery(_obj: QueryValue, prefix = ''): void {
    if (Array.isArray(_obj)) {
      _obj.forEach(item => {
        appendParam(`${prefix}[]`, item);
      });
    } else if (typeof _obj === 'object' && _obj !== null) {
      Object.entries(_obj).forEach(([key, value]) => {
        const fullKey = prefix ? `${prefix}[${key}]` : key;
        buildQuery(value, fullKey);
      });
    } else {
      appendParam(prefix, _obj);
    }
  }

  buildQuery(obj);

  return params;
}
